import { translations } from 'translations';

export const LOGIN_CODES = {
    201: translations.AUTH_PAGES.LOGIN_SUCCESSFUL,
    401: translations.ERRORS.LOGIN_UNSUCCESFUL,
    402: translations.ERRORS.WHITELABEL_402,
    403: translations.AUTH_PAGES.LOGIN_NO_ACCOUNT,
    404: translations.ERRORS.USER_NOT_FOUND,
    410: translations.ERRORS.INVITATIONS_ERROR,
    429: translations.AUTH_PAGES.VERIFICATION_CODE_MANY_ERROR_TOAST,
    500: translations.ERRORS.NETWORK_DEFAULT,
    503: translations.ERRORS.OUT_OF_SERVICE
}

